export default __webpack_public_path__ + "static/media/biz-dash-qr-codes.0cb59bfa.png";